import React from 'react';
import type { ThemePalette } from '../../theme/tokens';

export interface BallProps {
  n: number;
  size?: number;
  lucky?: boolean;
  muted?: boolean;
  matched?: boolean;
  c: ThemePalette;
  style?: React.CSSProperties;
}

export const Ball: React.FC<BallProps> = ({
  n,
  size = 40,
  lucky = false,
  muted = false,
  matched = false,
  c,
  style = {},
}) => {
  const bg = muted ? c.surfaceAlt : lucky ? c.lucky : c.ink;
  const fg = muted ? c.inkSoft : lucky ? '#fff' : c.bg;
  const shine =
    'radial-gradient(circle at 30% 25%, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0) 55%)';
  return (
    <div
      className="relative flex shrink-0 items-center justify-center rounded-full"
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        background: bg,
        color: fg,
        fontFamily: 'var(--font-mono)',
        fontWeight: 600,
        fontSize: size * 0.4,
        letterSpacing: 0,
        boxShadow: matched
          ? `0 0 0 2px ${c.win}, inset 0 -${size * 0.08}px ${size * 0.15}px rgba(0,0,0,0.18), 0 ${size * 0.05}px ${size * 0.1}px rgba(0,0,0,0.12)`
          : muted
            ? 'none'
            : `inset 0 -${size * 0.08}px ${size * 0.15}px rgba(0,0,0,0.18), 0 ${size * 0.05}px ${size * 0.1}px rgba(0,0,0,0.12)`,
        ...style,
      }}
      aria-label={matched ? `${n} matched winning number` : undefined}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-full"
        style={{ background: shine }}
      />
      <span className="relative z-[1]">{String(n).padStart(2, '0')}</span>
      {matched && (
        <span
          aria-hidden="true"
          className="absolute -right-1 -top-1 z-[2] flex items-center justify-center rounded-full"
          style={{
            width: Math.max(15, size * 0.44),
            height: Math.max(15, size * 0.44),
            background: c.win,
            boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
          }}
        >
          <svg
            width={Math.max(9, size * 0.26)}
            height={Math.max(9, size * 0.26)}
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M2.2 6.2l2.2 2.2 5-5"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </div>
  );
};
